import PropTypes from "prop-types";
import React from "react";

export const PriorityBoarding = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path d="M12.0033 22.7055C17.4508 22.7055 21.8669 18.2894 21.8669 12.842C21.8669 7.39446 17.4508 2.97839 12.0033 2.97839C6.55584 2.97839 2.13977 7.39446 2.13977 12.842C2.13977 18.2894 6.55584 22.7055 12.0033 22.7055Z" />
      <path
        d="M12.0033 2.98767C9.53412 2.98767 7.28453 3.89283 5.55408 5.39033V20.3188C7.28453 21.8163 9.54077 22.7214 12.0033 22.7214C14.4659 22.7214 16.6356 21.8735 18.3661 20.376L18.4526 5.39033C16.7221 3.89283 14.4659 2.98767 12.0033 2.98767Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.68053 5.10996C7.40394 3.69994 9.60124 2.85455 12.0033 2.85455C14.3959 2.85455 16.5965 3.69774 18.3195 5.10454V5.08294L18.5397 5.27374C20.6574 7.10817 22 9.81318 22 12.8353C22 15.8572 20.6575 18.5689 18.5397 20.4034L18.3195 20.5942V20.5904C16.5875 22.0378 14.4352 22.8546 12.0033 22.8546C9.60766 22.8546 7.40446 22.0092 5.68053 20.5991V20.6009L5.64063 20.5663C5.58218 20.518 5.52429 20.469 5.46697 20.4194L5.42097 20.3796V20.3758C3.32591 18.5419 2 15.8451 2 12.8419C2 9.81323 3.34254 7.1082 5.46027 5.27374L5.68053 5.08294V5.10996ZM5.41431 5.67163C3.48001 7.45157 2.26622 10.0003 2.26622 12.8419C2.26622 15.6772 3.48004 18.2318 5.41431 20.0122V5.67163ZM5.68719 20.2577C7.38826 21.7114 9.59573 22.5883 12.0033 22.5883C14.412 22.5883 16.5344 21.7669 18.2333 20.3146L18.3191 5.45111C16.6181 3.99756 14.4108 3.12078 12.0033 3.12078C9.58918 3.12078 7.38818 3.99765 5.68719 5.45142V20.2577ZM18.5857 20.0055C20.52 18.2252 21.7338 15.6705 21.7338 12.8353C21.7338 10.0001 20.52 7.4516 18.5857 5.67163V20.0055Z"
      />
      <path
        d="M18.2529 17.5141H5.75375C5.64061 17.5141 5.55408 17.4276 5.55408 17.3145V2.23295C5.55408 2.1198 5.64061 2.03328 5.75375 2.03328H18.2529C18.3661 2.03328 18.4526 2.1198 18.4526 2.23295V17.3145C18.4526 17.4276 18.3661 17.5141 18.2529 17.5141Z"
        fill="white"
      />
      <path d="M18.3195 20.4692C18.2263 20.4692 18.1531 20.5025 18.1531 20.4093V2.33278H5.72047V20.3095C5.72047 20.4027 5.68054 20.3428 5.58736 20.3428C5.49418 20.3428 5.3877 20.3095 5.3877 20.3095V2.2995C5.3877 2.13311 5.52081 2 5.6872 2H18.1864C18.3528 2 18.4859 2.13311 18.4859 2.2995V20.3095C18.4859 20.396 18.4127 20.4692 18.3195 20.4692Z" />
      <path d="M11.7603 14.8124C12.3464 15.3908 13.4644 15.9687 13.4644 15.9687C13.4879 15.9564 14.4789 15.4378 15.1304 14.8486C15.1304 14.8486 15.5153 14.975 15.6802 15.0292C16.7426 15.4088 16.9625 16.096 16.9625 16.3671C16.9624 16.638 16.9254 16.873 16.9254 16.873C16.9015 16.8942 15.854 17.8124 13.4644 17.8124C11.0918 17.8124 9.90083 16.8935 9.87457 16.873C9.87457 16.873 9.83751 16.638 9.83746 16.3671C9.83746 16.1141 10.0574 15.4088 11.1197 15.0292C11.3181 14.9581 11.7471 14.8168 11.7603 14.8124ZM13.4 10.6874C14.4913 10.6874 15.3794 11.5512 15.3795 12.7675C15.3795 13.9662 14.4913 15.0419 13.4 15.0419C12.3086 15.0419 11.4205 13.9662 11.4205 12.7675C11.439 11.5512 12.3087 10.6874 13.4 10.6874Z" />
      <mask id="mask0_8334_15179" maskUnits="userSpaceOnUse" x="9" y="10" width="8" height="8">
        <path d="M11.7603 14.8124C12.3464 15.3908 13.4644 15.9687 13.4644 15.9687C13.4879 15.9564 14.4789 15.4378 15.1304 14.8486C15.1304 14.8486 15.5153 14.975 15.6802 15.0292C16.7426 15.4088 16.9625 16.096 16.9625 16.3671C16.9624 16.638 16.9254 16.873 16.9254 16.873C16.9015 16.8942 15.854 17.8124 13.4644 17.8124C11.0918 17.8124 9.90083 16.8935 9.87457 16.873C9.87457 16.873 9.83751 16.638 9.83746 16.3671C9.83746 16.1141 10.0574 15.4088 11.1197 15.0292C11.3181 14.9581 11.7471 14.8168 11.7603 14.8124ZM13.4 10.6874C14.4913 10.6874 15.3794 11.5512 15.3795 12.7675C15.3795 13.9662 14.4913 15.0419 13.4 15.0419C12.3086 15.0419 11.4205 13.9662 11.4205 12.7675C11.439 11.5512 12.3087 10.6874 13.4 10.6874Z" />
      </mask>
      <g mask="url(#mask0_8334_15179)">
        <rect x="8.64996" y="9.49994" width="9.5" height="9.5" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.30447 8.88597C7.45013 9.02469 7.6863 9.02469 7.83197 8.88597L9.4332 7.36098L9.4332 11.4767C9.4332 11.6728 9.6002 11.8319 9.8062 11.8319C10.0122 11.8319 10.1792 11.6728 10.1792 11.4767L10.1792 7.36098L11.7804 8.88597C11.9261 9.02469 12.1623 9.02469 12.3079 8.88597C12.4536 8.74724 12.4536 8.52232 12.3079 8.38359L10.0699 6.25218C9.92428 6.11345 9.68811 6.11345 9.54245 6.25218L7.30447 8.38359C7.1588 8.52232 7.1588 8.74724 7.30447 8.88597Z"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      strokeWidth: "0",
      style,
      viewBox: "0 0 24 24",
    };
  }
};

PriorityBoarding.displayName = "PriorityBoardingIcon";

PriorityBoarding.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

PriorityBoarding.defaultProps = { role: "img" };
